<template>
  <div class="card log-entry">
    <div class="card-title p-2 m-0">
      <div class="d-flex">
        <div class="flex-grow-1">
          <i :class="logEntry.causer_icon + ' text-primary pe-1'"></i>
          {{ logEntry.causer_name ?? 'Unbekannt' }}
        </div>
        <div class="flex-grow-0">
          <i :class="'bi bi-clock-fill text-primary pe-1'"></i>
          {{ logEntry.log_date }} {{ trans('aspects.admin.common.time-suffix') }}
        </div>
      </div>
      <div class="d-flex">
        <div class="flex-grow-1 font-weight-bold">
          <i :class="'bi ' + getIconClass() + ' text-primary pe-1'"></i>
          {{
            trans(`aspects.${aspect}.event-log.events.models.${logEntry.event}`, {
              attribute: getEntryTitle(logEntry.properties.attributes ?? logEntry.properties, resourceType, trans),
            })
          }}
        </div>
      </div>
    </div>
    <div v-if="logEntry.properties" class="card-body p-2">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    logEntry: {
      type: Object,
      default: () => {},
    },
    resourceType: { type: String, default: () => '' },
  },
  setup(props) {
    const getEntryTitle = (attributes, resourceType, trans) => {
      if (props.logEntry.event === 'created') {
        return trans(`models.${resourceType}.name.singular`);
      }

      return trans(
        Object.keys(attributes).length > 1
          ? 'Daten'
          : trans(`models.${resourceType}.attributes.` + Object.keys(attributes).pop())
      );
    };

    const getIconClass = () => {
      if (props.logEntry.event === 'created') {
        return 'bi-file-earmark-plus';
      }

      return 'bi-pencil-fill';
    };

    return {
      getEntryTitle,
      getIconClass,
    };
  },
};
</script>
